// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"06e5dc2b","299":"c0a50127","348":"a3a95bf8","516":"12782665","695":"ed590f34"}[chunkId] + ".chunk.css";
};